import React from 'react'
import { Container } from 'app/components/layout/container'
import { PrivacySidebar } from './privacySidebar'
import { PrivacyContent } from './privacyContent'

import styles from './privacyPolicy.module.scss'

const PrivacyPolicy = () => {
  return (
    <Container className={styles.container}>
      <PrivacySidebar />
      <PrivacyContent />
    </Container>
  )
}

export { PrivacyPolicy }
